// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const stonjourner: PokeData = {
  "id": 874,
  "name": "stonjourner",
  "height": 25,
  "weight": 5200,
  "base_experience": 165,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "stomp",
    "mega-kick",
    "body-slam",
    "rock-throw",
    "rock-slide",
    "rock-tomb",
    "block",
    "gravity",
    "rock-polish",
    "stone-edge",
    "stealth-rock",
    "wide-guard",
    "heavy-slam"
  ],
  "moves": [
    "body-slam",
    "rock-throw",
    "rock-slide",
    "rock-tomb",
    "stealth-rock",
    "ancient-power",
    "rock-blast",
    "seismic-toss",
    "stone-crush",
    "stone-axe",
    "boulder_bash",
    "power-siphon",
    "rock-smash"
  ],
  "evolution_chain": {
    "id": 456,
    "item": null,
    "species": [
      {
        "name": "stonjourner",
        "order": 874,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 99,
    "ability_power": 176
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
